import React from 'react'
import Layout from '../../components/Layout/Layout'
import styles from '../../style/energyaudit.module.css'
import json from '../../data/energyaudit.json'
import { StaticImage } from 'gatsby-plugin-image'
import { StaticQuery, graphql } from 'gatsby'
import { AnchorLink } from 'gatsby-plugin-anchor-links'

export default function posts(){
    return(
        <StaticQuery
        query={graphql`
        query{
            allMarkdownRemark {
              nodes {
                html
                frontmatter {
                  title
                }
              }
            }
          }`}
          render={data => <EnergyAudit data={data.allMarkdownRemark}/>} 
          />
    )
}
function EnergyAudit({data}) {
    console.log(data.nodes)
    return (
        <Layout>
            <div className={styles.container}>
                <div className={styles.layout}>
                    <div className={styles.wrapper}> 
                            <h1 className="title"> <span className="underline">
                            Эрчим хүчний аудит
                            </span></h1>

                            <div className={styles.grid}>
                            <StaticImage src='../../images/energy.jpg' alt="audit" className={styles.image}/>
                            <div>
                            <div className={styles.html} dangerouslySetInnerHTML={{ __html: data.nodes[0].html}}/>
                            <h1 className="title"><span className="underline">ЭРЧИМ ХҮЧНИЙ АУДИТ ХИЙХ ПРОЦЕСС</span></h1>
                                <StaticImage src='../../images/audit-update.jpg' alt="audit"/>
                            <h1 className="title"><span className="underline">ЦАР ТАХЛЫН ҮЕИЙН ЭРЧИМ ХҮЧНИЙ ЦАХИМ АУДИТ</span></h1>
                            Короновирусын цар тахал дэлхий нийтэд өргөн тархаад байгаа өнөөгийн нөхцөл байдалд нийцүүлэн эрчим хүчний аудитыг цахимаар хийх боломжтой боллоо. Цахим аудитыг дараах дарааллаар хэрэгжүүлэх боломжтой. 
                            <table  className={styles.tab}>
                                <tr>
                                    <th>№</th>
                                    <th>Хүрэх үр дүн</th>
                                    <th>Хэлбэр</th>
                                </tr>
                                {json.map( d =>(
                                    <tr>
                                        <td style={{width: "20px"}}>{d.number}</td>
                                        <td>{d.outcome}
                                        </td>
                                        <td>{d.type}</td>
                                    </tr>
                                ))}
                                    <tr>
                                        <td>
                                            12
                                        </td>
                                        <td>
                                            Аудитын тайлан танилцуулах хурал 
                                            <ul className={styles.list}>
                                                <li>
                                                    Судалгаа
                                                </li>                                               
                                                <li>
                                                	Дүгнэлт
                                                </li>                                                
                                                <li>
                                                	Зөвлөмж
                                                </li>                                                
                                                <li>
                                                	Хэрэгжүүлэх төлөвлөгөө
                                                </li>
                                            </ul>
                                        </td>
                                        <td>
                                            Цахим хурал
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            13
                                        </td>
                                        <td>
                                            Аудитын тайлан, хэрэгжүүлэх төлөвлөгөөг хэвлэж баталгаажуулах, хүлээлгэн өгөх
                                            <ul className={styles.list}>
                                                <li>
                                                	Захиалагчид 1 хувь;
                                                </li>                                               
                                                <li>
                                                	Гүйцэтгэгчид 1 хувь;
                                                </li>                                                
                                                <li>
                                                	ЭХЗХ-нд 1 хувь
                                                </li>     
                                            </ul>
                                        </td>
                                        <td>
                                        Шуудангаар илгээх
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            14
                                        </td>
                                        <td>
                                        Гэрээ дүгнэсэн акт үйлдэх
                                        </td>
                                        <td>
                                        Шуудангаар илгээх
                                        </td>
                                    </tr>
                            </table>
                            Та эрчим хүчний аудит хийлгэх шийдвэрээ гаргасан бол <AnchorLink to="/#contact" className={styles.link}>энд</AnchorLink> дарж дэлгэрэнгүй мэдээлэл авна уу. 
                            </div>
                            </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}
